export default function preventDefault(handler) {
  return (e, ...tail) => {
    if (typeof handler === `function`) {
      handler(e, ...tail)
    }
    e.preventDefault()
  }
}
